/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { ServizioMensaAnagraficaRowDTO } from './servizio-mensa-anagrafica-row-dto';


export interface PagedModelServizioMensaAnagraficaRowDTO { 
    content?: Array<ServizioMensaAnagraficaRowDTO>;
    page?: PageMetadata;
}

